module.exports = __webpack_public_path__ + "static/media/bg.543e8f26.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/lesson-path/img/bg.png
// module id = 704
// module chunks = 1